function objectWithoutProperties(obj, exclude) {
  var target = {}
  for (var k in obj)
    if (
      Object.prototype.hasOwnProperty.call(obj, k) &&
      exclude.indexOf(k) === -1
    )
      target[k] = obj[k]
  return target
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vertical-progress-wrapper",
      class: !_vm.isEmptyChangelog ? "progress-vertical white" : "",
    },
    [
      _vm._l(_vm.changeLog, function (ref, idx) {
        var items = ref.items
        var sectionName = ref.sectionName
        return _c(
          "div",
          { key: sectionName + "-" + idx },
          [
            items[0]
              ? _c(
                  "div",
                  {
                    staticClass: "row mt-4",
                    class: _vm.toHyphens(sectionName) + "-section-item",
                  },
                  [
                    _c("div", { staticClass: "col-12 month-tag" }, [
                      _c(
                        "h4",
                        {
                          staticClass: "bold text-primary mb-4 text-capitalize",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.isCurrentMonth(sectionName)
                                  ? _vm.$t("client-profile.messages.thisMonth")
                                  : sectionName
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(items, function (ref, itemIdx) {
              var value = ref.value
              var operation = ref.operation
              var type = ref.type
              var userDetails = ref.userDetails
              var field = ref.field
              var rest$1 = objectWithoutProperties(ref, [
                "value",
                "operation",
                "type",
                "userDetails",
                "field",
              ])
              var rest = rest$1
              return _c(
                "div",
                {
                  key: sectionName + "-" + type + "-" + itemIdx,
                  staticClass: "row mb-4",
                  class: _vm.toHyphens(sectionName) + "-section-item",
                },
                [
                  _c("div", { staticClass: "progress-item col pr-0" }, [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.left",
                            value: {
                              title: _vm.insertionTimestampTooltip(
                                rest.insertionTimestamp
                              ),
                            },
                            expression:
                              "{\n            title: insertionTimestampTooltip(rest.insertionTimestamp)\n          }",
                            modifiers: { left: true },
                          },
                        ],
                        staticClass: "progress-item-circle white nav-link",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-archive",
                          staticStyle: {
                            "z-index": "50",
                            "font-size": "15px",
                            color: "#616161",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(_vm.changelogComponent(type), {
                        tag: "component",
                        attrs: {
                          value: value,
                          operation: operation,
                          field: field,
                          type: type,
                          "insertion-timestamp": rest.insertionTimestamp,
                          "user-details": userDetails,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.isEmptyChangelog
        ? _c("div", { staticClass: "row mt-5 pl-5" }, [
            _c("div", { staticClass: "col-12 text-center" }, [
              _c("img", {
                attrs: {
                  height: "100px",
                  src: require("@Broker/@Assets/icon/empty-timeline.png"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("h3", { staticClass: "text-gray mt-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("global.messages.noActivityToShow")) +
                    "\n      "
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }